import { Flex } from '@hopin-team/ui-flex';
import { getFromTheme } from '@hopin-team/ui-helper-deep-branding';
import styled from 'styled-components';

export const Footer = styled(Flex)`
  border-top: 2px solid
    ${({ theme }) => getFromTheme('COLOR.GREY["200"]', theme)};
`;
